module.exports = __webpack_public_path__ + "static/media/universal.81646b7b.svg";